import React, {useState, useEffect} from 'react';
import { BrowserRouter, Routes, Route, Link, Outlet } from 'react-router-dom';


function Job(){
return(
    <main>
        <h1>Hello World, this is Job!</h1>
        <Link to={"/"} className="project">
            <p>The Home Page Link</p>
        </Link>
        <Link to={"/about"} className="project">
            <p>The About Page Link</p>
        </Link>

    </main>
);

}
export default Job